import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "paragraph__glitch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["paragraph", { 'paragraph--glitch': this.glitch }])
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("span", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$slots?.default?.(), (child) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(child), {
          key: child.key
        }))
      }), 128))
    ])
  ], 2))
}